<template>
  <div
    v-b-tooltip.hover.viewport
    class="d-flex align-items-center"
    title="Mirror moves & resizes across every template"
  >
    <b-form-checkbox
      v-model="isSyncOn"
      class="sync-layout-toggle"
      :class="{ 'is-active': isSyncOn }"
      @change="onChange"
    >
      <svg
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M8 3 4 7l4 4" />
        <path d="M4 7h16" />
        <path d="m16 21 4-4-4-4" />
        <path d="M20 17H4" />
      </svg>

      <span>Sync Templates</span>
    </b-form-checkbox>
  </div>
</template>

<script>
import { isSyncLayoutOn, setSyncLayoutOn, onSyncLayoutChange } from '@frontend/group/modules/editor-control-popup/sync-layout';

export default {
  name: 'SyncLayoutToggle',

  data() {
    return {
      isSyncOn: isSyncLayoutOn(),
    };
  },

  mounted() {
    this.unsubscribe = onSyncLayoutChange((value) => {
      this.isSyncOn = value;
    });
  },

  beforeDestroy() {
    this.unsubscribe?.();
  },

  methods: {
    onChange(value) {
      setSyncLayoutOn(value);
    },
  },
};
</script>
<style lang="scss" scoped>
.sync-layout-toggle {
  margin: 0;
  padding: 0 !important;
}

.sync-layout-toggle::v-deep .custom-control-input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

.sync-layout-toggle::v-deep .custom-control-label::before,
.sync-layout-toggle::v-deep .custom-control-label::after {
  display: none !important;
}

.sync-layout-toggle::v-deep .custom-control-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  margin: 0;
  padding: 0 10px;
  border-radius: 6px;
  background: #ffffff;
  color: #4b5563;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;

  cursor: pointer;
  user-select: none;

  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.06);

  transition:
    color 0.15s ease,
    border-color 0.15s ease,
    background-color 0.15s ease;
}

.sync-layout-toggle::v-deep .custom-control-label:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}

.sync-layout-toggle.is-active::v-deep .custom-control-label {
  color: #159447;
  border-color: #b7e4c7;
}

.sync-layout-toggle::v-deep .custom-control-input:focus-visible
  + .custom-control-label {
  box-shadow: 0 0 0 3px rgba(21, 148, 71, 0.15);
}

.sync-layout-toggle::v-deep svg {
  flex: 0 0 auto;
}
</style>
